/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

/**
 * Validation error types
 */
export enum VALIDATION_ERROR_TYPE {
	REQUIRED = "required",
	INVALID_NUMBER = "invalid_number",
	VALUE_MIN = "value_min",
	VALUE_MAX = "value_max",
	INVALID_OPTION = "invalid_option"
}

/**
 * Base validation error interface
 */
export interface IValidatonErrorBase {
	type: VALIDATION_ERROR_TYPE;
	message: string;
}

/**
 * Numeric related validation error
 */
export interface IValidationErrorNumeric extends IValidatonErrorBase {
	type: VALIDATION_ERROR_TYPE.VALUE_MAX|VALIDATION_ERROR_TYPE.VALUE_MIN;
	min?: number;
	max?: number;
}

/**
 * Validation error types
 */
export type TValidatonError = IValidatonErrorBase|IValidationErrorNumeric;
